import AdminLayout from "./AdminLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { WorkbenchTab } from "./workbench/WorkbenchTab";
import { BidCheckTab } from "./workbench/BidCheckTab";
import { CompanyProfilesTab } from "./workbench/CompanyProfilesTab";
import { Bot } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function AdminAiAssistantPage() {
  return (
    <AdminLayout tab="ai-assistant">
      <div className="max-w-6xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Bot className="h-6 w-6 text-primary" />
            <h1 className="text-2xl font-bold">招標工作台</h1>
            <Badge variant="secondary" className="text-xs ml-1">管理員內測</Badge>
          </div>
          <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
            模擬付費會員的工作台體驗。將已收藏的學校招標轉化為實際投標，並在過程中提供 AI 輔助。
          </p>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="workbench" className="w-full">
          <TabsList className="mb-6 grid w-full max-w-md grid-cols-3">
            <TabsTrigger value="workbench">工作台</TabsTrigger>
            <TabsTrigger value="bid-check">標書審核</TabsTrigger>
            <TabsTrigger value="profiles">公司資料</TabsTrigger>
          </TabsList>

          <TabsContent value="workbench" className="mt-0 outline-none">
            <WorkbenchTab />
          </TabsContent>

          <TabsContent value="bid-check" className="mt-0 outline-none">
            <BidCheckTab />
          </TabsContent>

          <TabsContent value="profiles" className="mt-0 outline-none">
            <CompanyProfilesTab />
          </TabsContent>
        </Tabs>

      </div>
    </AdminLayout>
  );
}
